import { z } from "zod";

export const channelItemSchema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    visible_title: z.string().min(1, "forms.general-validation.visible_title_required"),
    integration: z.string().min(1, "forms.general-validation.integration_required"),
    distribution: z.string().min(1, "forms.pingtree.validation.distribution_required"),
    action: z.string().min(1, "forms.pingtree.validation.action_required"),
    active: z.boolean(),
});

export const pingtreeFormSchema = z.object({
    channels: z.record(z.string(), channelItemSchema),
});

export type ChannelItemFormData = z.infer<typeof channelItemSchema>;
export type PingtreeFormData = z.infer<typeof pingtreeFormSchema>;
